module.exports = __webpack_public_path__ + "static/media/svg-2.4a122f73.svg";